import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Quote, Star } from "lucide-react";

export default function Testimonials({ country, treatment, limit = 6 }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const params = { limit };
    if (country) params.country = country;
    if (treatment) params.treatment = treatment;
    http.get("/testimonials", { params }).then(r => setItems(r.data));
  }, [country, treatment, limit]);
  if (items.length === 0) return null;
  return (
    <section className="py-24 bg-[#00030E]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
          <div>
            <div className="overline mb-3">Patient Stories</div>
            <h2 className="font-serif text-3xl md:text-5xl text-[#F3E9EC]">Words from patients we've cared for</h2>
          </div>
          <p className="text-sm text-[#F3E9EC]/50 max-w-xs">Real testimonials from international patients coordinated by MediPats. Display names shown with patient consent.</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(t => (
            <div key={t.id} className="mp-card p-7 flex flex-col" data-testid={`testimonial-${t.id}`}>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full flex items-center justify-center font-serif text-lg text-white" style={{background: "linear-gradient(135deg,#B47A9A,#5E3A5C)"}}>
                  {t.patient_display_name.charAt(0)}
                </div>
                <div>
                  <div className="font-serif text-lg text-[#F3E9EC]">{t.patient_display_name}</div>
                  <div className="text-xs font-mono uppercase tracking-widest text-[#B47A9A]">{t.country}</div>
                </div>
              </div>
              <Quote className="w-6 h-6 text-[#5E3A5C] mt-5"/>
              <p className="mt-3 text-[#F3E9EC]/80 text-sm leading-relaxed italic flex-1">"{t.quote}"</p>
              <div className="mt-5 pt-4 border-t border-[#5E3A5C]/30 flex items-center justify-between">
                {t.treatment_name && <span className="text-xs px-2.5 py-1 rounded-full border border-[#5E3A5C]/60 text-[#F3E9EC]/75">{t.treatment_name}</span>}
                <div className="flex items-center gap-0.5">
                  {[...Array(t.rating || 5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-[#B47A9A]" fill="#B47A9A"/>)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
